import { useState } from 'react';
import { Box, EmailOutlinedIcon, Button, Typography, Stack, Loader } from 'src/components';
import useIsMobile from 'src/hooks/useIsMobile';
import LogoDark from 'src/assets/logo-rect.png';
import { GoogleAuth, AppleAuth } from '../index';
import { Capacitor } from '@capacitor/core';

import NotLoggedInHero from 'src/assets/not-logged-in.png';

export default function NotLoggedIn({ handleCurrentViewChange, handleSuccess }) {
    const [loading, setLoading] = useState(false);

    const isMobile = useIsMobile();

    const contentMinHeight = 'max(300px, 35vh)';
    const imageHeight = `calc(100vh - ${contentMinHeight})`;
    const contentMargin = `calc(100vh - ${contentMinHeight} - 20px + var(--safe-area-top))`;

    const platform = Capacitor.getPlatform();
    const isAppleMobile = platform === 'ios'; 

    return (
        <Box sx={{ 
            marginTop: 'calc(0px - var(--safe-area-top))',
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
            }}>

                {isMobile && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            width: '100vw',
                            height: imageHeight,
                            backgroundImage: `url(${NotLoggedInHero})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            zIndex: -1
                        }}
                    >
                        
                        {/* <Box
                            component="img"
                            src={Logo}
                            alt="PanAm Logo"
                            sx={{
                                position: 'absolute',
                                bottom: 40,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '60%',
                                filter: 'drop-shadow(0 0 6px rgba(0,0,0,0.8))', // subtle shadow/glow
                            }}
                            /> */}

                        {/* Wavy Bottom */}
                        <Box sx={{ 
                            position: "absolute", 
                            bottom: -1, 
                            left: 0, 
                            right: 0, 
                            lineHeight: 0,
                            zIndex: 1 
                        }}>
                            <svg viewBox="0 0 1440 150" preserveAspectRatio="none" style={{ width: '100%', height: 50 }}>
                                <path
                                    d="M0,50 C360,120 1080,120 1440,50 L1440,150 L0,150 Z"
                                    fill="#FFFFFF"
                                />
                            </svg>
                        </Box>
                    </Box>
                )}

                <Box sx={{mt: isMobile ? contentMargin : '', gap: 4, height: isMobile ? contentMinHeight : ''}}>

                    <Box
                        component="img"
                        src={LogoDark}
                        alt="PanAm Logo"
                        sx={{
                            width: isMobile ? '50%' : '180px',
                            mx: 'auto',
                        }}
                        />

                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        Explore the Pan-American Highway
                    </Typography>

                    <Stack spacing={2} sx={{ width: '100%', mt: 2, mx: 'auto' }}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => handleCurrentViewChange('Register')}
                            sx={{ 
                                borderRadius: 1,
                                position: 'relative',
                                justifyContent: 'center',
                                '& .MuiButton-startIcon': {
                                    position: 'absolute',
                                    left: 22,
                                    marginRight: 0
                                }
                            }}
                            startIcon={<EmailOutlinedIcon />}
                        >
                            Sign up with Email
                        </Button>

                        <Stack direction="row" spacing={2}>
                            <GoogleAuth setLoading={setLoading} handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess} showButtonText={!isAppleMobile} />
                            
                            <AppleAuth setLoading={setLoading} handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess} showButtonText={false} />
                        </Stack>
                    </Stack>

                    <Typography variant="body2" sx={{ mt: 1.5 }}>
                        Already have an account?{' '}
                        <Box
                            component="span"
                            onClick={() => handleCurrentViewChange('Login')}
                            sx={{
                                color: 'primary.main',
                                fontWeight: 600,
                                cursor: 'pointer',
                                textDecoration: 'none',
                            }}
                        >
                            Login
                        </Box>
                    </Typography>
                </Box>

                {loading && <Loader fullscreen={isMobile} />}

        </Box>
    );
}